import React, { useState } from "react";
import "./WelocateHeader.css";
import welocateLogo from "../../img/icons/welocate-bl.svg";
import WLSearchbar from "./WLSearchbar";
import WLSearchbarV2 from "./WLSearchbarV2";
import LanguageIcon from "@mui/icons-material/Language";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import WLAskAIPanel from "./WLAskAIPanel";

const WelocateHeader = ({
  selectedCity,
  onCitySelect,
  listingMode = "all",
  onViewChange,
  myCount = 0,
  allCount = 0,
  userInitials = "RH",
  refetch,
  onSelectListing,
  aiOpenRequest,
  filters,
  onBedroomApply,
  onAreaApply,
  onTypeApply,
  onStatusApply,
  onEnergyLabelApply,
  uxExperience = 1,
}) => {
  const [askAIOpen, setAskAIOpen] = useState(false);
  const [askAIQuery, setAskAIQuery] = useState("");

  const SearchbarComponent = uxExperience === 2 ? WLSearchbarV2 : WLSearchbar;

  const handleAiSearch = (query) => {
    setAskAIQuery(query);
    setAskAIOpen(true);
  };

  return (
    <React.Fragment>
      <div className="wl-header-container">
        <div className="wl-header-left">
          <img src={welocateLogo} alt="company-logo" />
          <SearchbarComponent
            selectedCity={selectedCity}
            onCitySelect={onCitySelect}
            listingMode={listingMode}
            onViewChange={onViewChange}
            onAdd={refetch}
            onSelectListing={onSelectListing}
            aiOpenRequest={aiOpenRequest}
            filters={filters}
            onBedroomApply={onBedroomApply}
            onAreaApply={onAreaApply}
            onTypeApply={onTypeApply}
            onStatusApply={onStatusApply}
            onEnergyLabelApply={onEnergyLabelApply}
            onAiSearch={handleAiSearch}
          />
          <button
            className="wl-ask-ai"
            type="button"
            onClick={() => setAskAIOpen(true)}
            style={uxExperience === 2 ? { display: "none" } : undefined}
          >
            <AutoAwesomeIcon className="wl-ask-ai-icon" />
            <span>Ask AI to find your property</span>
          </button>
        </div>

        <div className="wl-header-right">
          <div className="wl-view-toggle">
            <button
              className={`wl-view-option${
                listingMode === "my" ? " wl-view-option--active" : ""
              }`}
              onClick={() => onViewChange("my")}
            >
              <div className="wl-avatar">{userInitials}</div>
              <span className="wl-view-label">My listings</span>
              <span className="wl-view-count">{myCount}</span>
            </button>
            <button
              className={`wl-view-option${
                listingMode === "all" ? " wl-view-option--active" : ""
              }`}
              onClick={() => onViewChange("all")}
            >
              <LanguageIcon className="wl-globe-icon" />
              <span className="wl-view-label">All listings</span>
              <span className="wl-view-count">{allCount}</span>
            </button>
          </div>
        </div>
      </div>
      <WLAskAIPanel
        open={askAIOpen}
        onClose={() => {
          setAskAIOpen(false);
          setAskAIQuery("");
        }}
        onAdd={refetch}
        initialQuery={askAIQuery}
      />
    </React.Fragment>
  );
};

export default WelocateHeader;
